<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <v-card>
      <v-card-title>Send SMS</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="smsType" label="SMS Type" :items="smsTypes" dense outlined hide-details></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea dense outlined hide-details v-model="smsBody"></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submit">SEND</v-btn>
        <v-btn color="primary" small outlined @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapState,mapActions} from 'vuex';
  export default {
    data() {
      return {
        smsType: 'confirmAppointment',
        smsTypes: [
          {value:'confirmAppointment',text:'Confirm Appointment'},
          {value:'noContact',text:'No contact'},
        ],
        smsBody: '',
        customerName: '',
        agentName: '',
      }
    },
    props: ['dialogOpen'],
    computed: {
      ...mapState('leads', ['currentLead','currentLeadLoading']),
      ...mapState('globals', ['currentUser']),
    },
    watch: {
      smsType(val){
        if(val!==''){
          this.smsBody = (this.smsType==='confirmAppointment')?
            `Hello ${this.customerName}, I just want to confirm our appointment for ______ on _____. Looking forward to our call. Rgds, ${this.agentName}. bOnline`:
            `Hello ${this.customerName}, I tried to contact you regarding your enquiry. Please call me on 020 3617 9950 so we can discuss. Rgds, ${this.agentName}. bOnline`;
        }
      },
      dialogOpen(open) {
        if(open){
          this.customerName = (this.currentLead.contact.name!==null)?this.currentLead.contact.name.split(' ')[0]:'______';
          this.agentName = this.currentUser.long_name.split(' ')[0];
          this.smsBody = `Hello ${this.customerName}, I just want to confirm our appointment for ______ on _____. Looking forward to our call. Rgds, ${this.agentName}. bOnline`;
        }
      },
    },
    methods: {
      ...mapActions('leads',['sendSms']),
      async submit() {
        let success = await this.sendSms({id:this.currentLead.id,data:{body:this.smsBody}});
        if(success){
          this.close();
        }
      },
      close() {
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
